package com.flowyride.feature.planner.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.flowyride.feature.planner.ImportedRideUiState
import com.flowyride.feature.planner.PlannerAction
import com.flowyride.feature.planner.resources.Res
import com.flowyride.feature.planner.resources.imported_close
import com.flowyride.feature.planner.resources.imported_hint
import com.flowyride.feature.planner.resources.imported_title
import org.jetbrains.compose.resources.stringResource

/** Replaces the stop fields while an imported line is shown: it cannot be edited. */
@Composable
internal fun ImportedRideSection(imported: ImportedRideUiState, onAction: (PlannerAction) -> Unit, modifier: Modifier = Modifier) {
    Column(modifier, verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            Text(stringResource(Res.string.imported_title), style = MaterialTheme.typography.titleMedium)
            ImportedBadge()
        }
        Text(imported.name, style = MaterialTheme.typography.bodyLarge)
        Text(
            stringResource(Res.string.imported_hint),
            style = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        OutlinedButton(onClick = { onAction(PlannerAction.CloseImported) }) {
            Text(stringResource(Res.string.imported_close))
        }
    }
}
